module.exports = __webpack_public_path__ + "aa417961c1094a2c9dd66c65cc6c2fe7.png";